import { useMutation, useQueryClient } from '@tanstack/react-query';
import { usersService } from '@/services';

export function useAdminResetPassword() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (email: string) => {
      const result = await usersService.adminResetPassword(email);
      if (!result.success)
        throw new Error(result.error || 'Falha ao enviar link de redefinição');
      return result.message;
    },
    onSuccess: async () => {
      await Promise.all([
        queryClient.refetchQueries({ queryKey: ['users'] }),
        queryClient.refetchQueries({ queryKey: ['advisories-users'] }),
        queryClient.refetchQueries({ queryKey: ['broker-users'] }),
      ]);
    },
    onSettled: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['users'] }),
        queryClient.invalidateQueries({ queryKey: ['advisories-users'] }),
        queryClient.invalidateQueries({ queryKey: ['broker-users'] }),
      ]);
    },
  });
}
